import type { TAdminDashboardInfo } from 'app/pages/Admin/DashboardPage/types/TAdminDashboardInfo';

type TProps = {
  dashboard?: Partial<TAdminDashboardInfo>;
};

type TQueueJob = string | { id?: string; name?: string; failedReason?: string | null };

const getJobKey = (job: TQueueJob, index: number) => {
  if (typeof job === 'string') {
    return job;
  }
  return job.id || `${job.name || 'job'}-${index}`;
};

const getJobLabel = (job: TQueueJob) => {
  if (typeof job === 'string') {
    return job;
  }
  return job.id || job.name || 'Unknown job';
};

const getJobMeta = (job: TQueueJob) => {
  if (typeof job === 'string') {
    return null;
  }
  return job.failedReason || job.name || null;
};

const JobList = ({ title, jobs, emptyMessage }: { title: string; jobs?: TQueueJob[]; emptyMessage: string }) => (
  <div className="bg-[var(--color-surface)] shadow-[0_8px_10px_rgba(0,0,0,0.05)] rounded-[10px] p-5 mb-5">
    <div className="text-[var(--color-text-muted)] font-medium text-lg leading-[150%] mb-4">{title}</div>
    <div className="max-h-[300px] overflow-y-auto">
      {!jobs?.length ? (
        <div className="p-2.5">{emptyMessage}</div>
      ) : (
        jobs.map((job, index) => (
          <div key={getJobKey(job, index)} className="p-2.5 last:border-b-0">
            <div className="text-[var(--color-text)] font-medium mb-1">{getJobLabel(job)}</div>
            {getJobMeta(job) ? (
              <div className="text-[var(--color-text-subtle)] text-xs break-all">{getJobMeta(job)}</div>
            ) : null}
          </div>
        ))
      )}
    </div>
  </div>
);

export const QueueJobsSection = ({ dashboard }: TProps) => (
  <div className="mt-2 w-full grid grid-cols-1 md:grid-cols-2 gap-2.5">
    <JobList
      title="Active Transcript Submitter Jobs"
      jobs={dashboard?.activeTranscriptSubmitterJobs as TQueueJob[] | undefined}
      emptyMessage="No active jobs"
    />
    <JobList
      title="Failed Transcript Submitter Jobs"
      jobs={dashboard?.failedTranscriptSubmitterJobs as TQueueJob[] | undefined}
      emptyMessage="No failed jobs"
    />
  </div>
);
